export type ATTACHMENT = "ATTACHMENT";
const ATTACHMENT: ATTACHMENT = "ATTACHMENT";

export type MESSAGE_WITH_ATTACHMENTS = "MESSAGE_WITH_ATTACHMENTS";
const MESSAGE_WITH_ATTACHMENTS: MESSAGE_WITH_ATTACHMENTS = "MESSAGE_WITH_ATTACHMENTS";

export type CALL_ENDED = "CALL_ENDED";
const CALL_ENDED: CALL_ENDED = "CALL_ENDED";

export type CALL_ANSWERED = "CALL_ANSWERED";
const CALL_ANSWERED: CALL_ANSWERED = "CALL_ANSWERED";

export type CALL_STARTED = "CALL_STARTED";
const CALL_STARTED: CALL_STARTED = "CALL_STARTED";

export type CONTACT_ENQUIRY = "CONTACT_ENQUIRY";
const CONTACT_ENQUIRY: CONTACT_ENQUIRY = "CONTACT_ENQUIRY";

export type CONTACT_ENQUIRY_WITHOUT_GDPR = "CONTACT_ENQUIRY_WITHOUT_GDPR";
const CONTACT_ENQUIRY_WITHOUT_GDPR: CONTACT_ENQUIRY_WITHOUT_GDPR = "CONTACT_ENQUIRY_WITHOUT_GDPR";

export type ASSIGNEE_CHANGED = "ASSIGNEE_CHANGED";
const ASSIGNEE_CHANGED: ASSIGNEE_CHANGED = "ASSIGNEE_CHANGED";

export type ASSIGNEE_REMOVED = "ASSIGNEE_REMOVED";
const ASSIGNEE_REMOVED: ASSIGNEE_REMOVED = "ASSIGNEE_REMOVED";

export type STATUS_CHANGED = "STATUS_CHANGED";
const STATUS_CHANGED: STATUS_CHANGED = "STATUS_CHANGED";

export type FOLLOWER_ADDED = "FOLLOWER_ADDED";
const FOLLOWER_ADDED: FOLLOWER_ADDED = "FOLLOWER_ADDED";

export type ALL_FOLLOWERS_REMOVED = "ALL_FOLLOWERS_REMOVED";
const ALL_FOLLOWERS_REMOVED: ALL_FOLLOWERS_REMOVED = "ALL_FOLLOWERS_REMOVED";

export type FOLLOWER_REMOVED = "FOLLOWER_REMOVED";
const FOLLOWER_REMOVED: FOLLOWER_REMOVED = "FOLLOWER_REMOVED";

export type MEETING_SCHEDULED = "MEETING_SCHEDULED";
const MEETING_SCHEDULED: MEETING_SCHEDULED = "MEETING_SCHEDULED";

export type MEETING_RESCHEDULED = "MEETING_RESCHEDULED";
const MEETING_RESCHEDULED: MEETING_RESCHEDULED = "MEETING_RESCHEDULED";

export type MEETING_CANCELLED = "MEETING_CANCELLED";
const MEETING_CANCELLED: MEETING_CANCELLED = "MEETING_CANCELLED";

export type MEETING = "MEETING";
const MEETING: MEETING = "MEETING";

export type NOTE = "NOTE";
const NOTE: NOTE = "NOTE";

export type LEKTA_MESSAGE = "LEKTA_MESSAGE";
const LEKTA_MESSAGE: LEKTA_MESSAGE = "LEKTA_MESSAGE";

export type CALL_UNSUCCESSFUL = "CALL_UNSUCCESSFUL";
const CALL_UNSUCCESSFUL: CALL_UNSUCCESSFUL = "CALL_UNSUCCESSFUL";

export type CALL_PROPOSAL = "CALL_PROPOSAL";
const CALL_PROPOSAL: CALL_PROPOSAL = "CALL_PROPOSAL";

export type COBROWSING_PROPOSAL = "COBROWSING_PROPOSAL";
const COBROWSING_PROPOSAL: COBROWSING_PROPOSAL = "COBROWSING_PROPOSAL";

export type COBROWSING_ACCEPTATION = "COBROWSING_ACCEPTATION";
const COBROWSING_ACCEPTATION: COBROWSING_ACCEPTATION = "COBROWSING_ACCEPTATION";

export type COBROWSING_ENDED = "COBROWSING_ENDED";
const COBROWSING_ENDED: COBROWSING_ENDED = "COBROWSING_ENDED";

export type COBROWSING_SESSION_ENDED = "COBROWSING_SESSION_ENDED";
const COBROWSING_SESSION_ENDED: COBROWSING_SESSION_ENDED = "COBROWSING_SESSION_ENDED";

export type COBROWSING_SESSION_STARTED = "COBROWSING_SESSION_STARTED";
const COBROWSING_SESSION_STARTED: COBROWSING_SESSION_STARTED = "COBROWSING_SESSION_STARTED";

export type MESSAGE_WITH_FORM = "MESSAGE_WITH_FORM";
const MESSAGE_WITH_FORM: MESSAGE_WITH_FORM = "MESSAGE_WITH_FORM";

export type FORM_SUBMITTED = "FORM_SUBMITTED";
const FORM_SUBMITTED: FORM_SUBMITTED = "FORM_SUBMITTED";

export type LEAD_TAGS_UPDATE = "LEAD_TAGS_UPDATE";
const LEAD_TAGS_UPDATE: LEAD_TAGS_UPDATE = "LEAD_TAGS_UPDATE";

export type LEAD_TOPICS_UPDATE = "LEAD_TOPICS_UPDATE";
const LEAD_TOPICS_UPDATE: LEAD_TOPICS_UPDATE = "LEAD_TOPICS_UPDATE";

export type ROOM_SUMMARY = "ROOM_SUMMARY";
const ROOM_SUMMARY: ROOM_SUMMARY = "ROOM_SUMMARY";

export type EXTERNAL_MESSAGE = "EXTERNAL_MESSAGE";
const EXTERNAL_MESSAGE: EXTERNAL_MESSAGE = "EXTERNAL_MESSAGE";

export type MAXIMIZE_WIDGET = "MAXIMIZE_WIDGET";
const MAXIMIZE_WIDGET: MAXIMIZE_WIDGET = "MAXIMIZE_WIDGET";

export type FILE_DOWNLOADED = "FILE_DOWNLOADED";
const FILE_DOWNLOADED: FILE_DOWNLOADED = "FILE_DOWNLOADED";

export type LINK_CLICKED = "LINK_CLICKED";
const LINK_CLICKED: LINK_CLICKED = "LINK_CLICKED";

export type MessageTag =
  | ATTACHMENT
  | CALL_ENDED
  | CALL_ANSWERED
  | CONTACT_ENQUIRY
  | CONTACT_ENQUIRY_WITHOUT_GDPR
  | MESSAGE_WITH_ATTACHMENTS
  | ASSIGNEE_CHANGED
  | ASSIGNEE_REMOVED
  | NOTE
  | STATUS_CHANGED
  | FOLLOWER_ADDED
  | ALL_FOLLOWERS_REMOVED
  | FOLLOWER_REMOVED
  | MEETING_SCHEDULED
  | MEETING_RESCHEDULED
  | MEETING_CANCELLED
  | MEETING
  | LEKTA_MESSAGE
  | CALL_UNSUCCESSFUL
  | CALL_PROPOSAL
  | CALL_STARTED
  | COBROWSING_PROPOSAL
  | COBROWSING_ACCEPTATION
  | COBROWSING_ENDED
  | COBROWSING_SESSION_ENDED
  | COBROWSING_SESSION_STARTED
  | MESSAGE_WITH_FORM
  | FORM_SUBMITTED
  | LEAD_TAGS_UPDATE
  | LEAD_TOPICS_UPDATE
  | ROOM_SUMMARY
  | EXTERNAL_MESSAGE
  | MAXIMIZE_WIDGET
  | LINK_CLICKED
  | FILE_DOWNLOADED;

export const MessageTag = {
  ATTACHMENT,
  CALL_ENDED,
  CALL_ANSWERED,
  CONTACT_ENQUIRY,
  CONTACT_ENQUIRY_WITHOUT_GDPR,
  MESSAGE_WITH_ATTACHMENTS,
  ASSIGNEE_CHANGED,
  ASSIGNEE_REMOVED,
  NOTE,
  STATUS_CHANGED,
  FOLLOWER_ADDED,
  ALL_FOLLOWERS_REMOVED,
  FOLLOWER_REMOVED,
  MEETING_SCHEDULED,
  MEETING_RESCHEDULED,
  MEETING_CANCELLED,
  MEETING,
  LEKTA_MESSAGE,
  CALL_UNSUCCESSFUL,
  CALL_PROPOSAL,
  CALL_STARTED,
  COBROWSING_PROPOSAL,
  COBROWSING_ACCEPTATION,
  COBROWSING_ENDED,
  COBROWSING_SESSION_ENDED,
  COBROWSING_SESSION_STARTED,
  MESSAGE_WITH_FORM,
  FORM_SUBMITTED,
  LEAD_TAGS_UPDATE,
  LEAD_TOPICS_UPDATE,
  ROOM_SUMMARY,
  EXTERNAL_MESSAGE,
  MAXIMIZE_WIDGET,
  FILE_DOWNLOADED,
  LINK_CLICKED
};
